module.exports = __webpack_public_path__ + "static/media/diamonds-queen.5f8ffec4.png";